"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const heartempty = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-heartempty` : '') + (description ? ` desc-heartempty` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-heartempty"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-heartempty"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.8733 3.7911L11.9988 4.6913L11.1249 3.79095C9.77752 2.40188 7.86001 1.76369 5.97361 2.07925C4.08981 2.39436 2.47097 3.62139 1.62115 5.37325L1.51261 5.60972C0.552104 7.83644 0.966056 10.416 2.54762 12.1951L11.4378 21.7552C11.7412 22.0816 12.2572 22.0816 12.5607 21.7552L21.2825 12.3746C23.0674 10.5341 23.5114 7.71171 22.3772 5.37331L22.2529 5.13113C21.3634 3.49797 19.811 2.37804 18.0248 2.07925C16.1384 1.76369 14.2208 2.40188 12.8733 3.7911ZM17.7721 3.59672C19.0901 3.81719 20.2406 4.64719 20.8971 5.85233L21.0049 6.06217L21.1005 6.27287C21.7907 7.90127 21.4892 9.81613 20.3271 11.1442L11.9988 20.1015L3.83968 11.3285C2.53405 9.98319 2.17122 7.95958 2.91459 6.23589L3.00886 6.03056C3.63552 4.73917 4.83594 3.82929 6.2263 3.59672C7.61407 3.36457 9.0265 3.83467 10.0245 4.86353L11.449 6.3313C11.7504 6.64179 12.248 6.64179 12.5493 6.3313L13.9737 4.86367C14.9719 3.83467 16.3843 3.36457 17.7721 3.59672Z",
    fill: "inherit"
  }));
};
var _default = exports.default = heartempty;